export default __webpack_public_path__ + "static/bar-with-labels-5c86e78a0a67def16e2aab75f13f11bc.png";